"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inquiry = require("@/api/inquiry.js");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _dictionary = require("@/config/dictionary");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'proofExam',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      loading: true,
      tableData: [],
      total: 0,
      //总页数
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      conditionData: '',
      //来自子组件的数据
      date: '',
      caseState: _dictionary.dictionary.caseState,
      caseDealing: _dictionary.dictionary.caseDealing,
      fileVisble: false,
      MaterialData: [],
      fileLoading: false,
      fileAdoptVisble: false,
      keyId: '',
      ruleForm: {
        fileName: ''
      },
      num: '',
      currentCaseInfo: {} // 当前案件信息
    };
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {},
  components: {
    Caseconditons: _index.default
  },
  methods: {
    // 初始化数据列表
    init: function init() {
      var _this = this;
      (0, _inquiry.findResCaseByPage)({
        limit: this.pageLimit,
        page: this.currentPage
      }).then(function (res) {
        if (res.code == 1) {
          _this.loading = false;
          _this.tableData = res.rows;
          _this.total = res.total;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: 'inquiryDetail',
        params: {
          caseId: val
        }
      });
    },
    // 表格点击查看
    handleClick: function handleClick(val) {
      var _this2 = this;
      this.currentCaseInfo = val; // 保存当前案件信息
      this.fileVisble = true;
      this.fileLoading = true;
      (0, _inquiry.findResCaseProof)({
        caseId: val.caseId
      }).then(function (res) {
        if (res.code == 1) {
          _this2.fileLoading = false;
          _this2.MaterialData = res.data.caseFiles;
        } else {
          _this2.$message.error(res.msg);
        }
      });
    },
    //点击筛选，发送请求列表
    screen: function screen(data) {
      var _this3 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: this.num,
        limit: this.pageLimit,
        page: 1
      };
      this.conditionData = postData;
      (0, _inquiry.findResCaseByPage)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this3.loading = false;
          _this3.tableData = res.rows;
          _this3.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.num = '';
      this.currentPage = 1;
      this.init();
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      var _this4 = this;
      this.pageLimit = val;
      if (this.num) {
        // 有筛选条件的情况下
        (0, _inquiry.findResCaseByPage)({
          caseId: this.num,
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this4.tableData = res.rows;
            _this4.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.findResCaseByPage)({
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this4.tableData = res.rows;
            _this4.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this5 = this;
      if (this.num) {
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        // 有筛选条件的情况下
        (0, _inquiry.findResCaseByPage)({
          caseId: this.num,
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this5.tableData = res.rows;
            _this5.total = res.total;
            _this5.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.findResCaseByPage)({
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this5.tableData = res.rows;
            _this5.total = res.total;
            _this5.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;